const account={
    updatePermissionIndex:null,
    popupName:null,

    upgradePermission:null,
};

export default account;